import templateUrl from './change-password.html';

export default {
  templateUrl,
  bindings: {
    credentials: '<',
    passwordChanged: '&',
    requireCurrentPassword: '<'
  },
  controller: class ChangePasswordComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.passwordChanged(
        this.EventEmitter({
          credentials: this.credentials
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/change-password/change-password.component.js